import { usePublicAppContext } from '_core/context/public-app-context';

export const ReviewWidget = () => {
  const { locale } = usePublicAppContext();

  return (
    <div className="border border-secondary-700 rounded-lg shadow-2 py-4 px-6 mt-10 max-sm:mt-8">
      <div
        className="review-widget_net"
        data-uuid="9d421556-d351-48a2-8aeb-737f2ba1d394"
        data-template="2"
        data-lang={locale}
        data-theme="light"
      />
    </div>
  );
};
